import SecureMessage from 'modules/messages/SecureMessages/SecureMessage.jsx';
const MessagesGlobalScreen = () => {
  return <SecureMessage isGlobalMessagesScreen={true} />;
};

export default MessagesGlobalScreen;
